(ns practitest.frontend.forms3.entity-form.collapsible-section
  (:require
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.buttons :as buttons]
    [reagent.core :as reagent]))

(defn collapsible-section [{:keys [entity-type storage-key default-collapsed?]}]
  (let [collapsed? (reagent/atom (if entity-type
                                   (grid-storage/get-section-collapsed entity-type storage-key (boolean default-collapsed?))
                                   (boolean default-collapsed?)))]
    (fn [{:keys [class style title header-actions on-toggle override-collapsed? hide-content? id]} & children]
      (let [effective-collapsed? (if (some? override-collapsed?) override-collapsed? @collapsed?)]
        (into
          [:div (cond-> {:class (str class (when effective-collapsed? " section-collapsed"))}
                        id    (assoc :id id)
                        style (assoc :style style))
           [:div.header {:class (when effective-collapsed? "collapsed")}
            [buttons/icon-button
             {:icon     (if effective-collapsed? [icons/mux-chevron-right] [icons/mux-chevron-down2])
              :on-click #(let [new-state (not effective-collapsed?)]
                           (when-not (some? override-collapsed?)
                             (reset! collapsed? new-state)
                             (grid-storage/set-section-collapsed entity-type storage-key new-state))
                           (when on-toggle (on-toggle new-state)))}]
            [:div.title title]
            header-actions]]
          (when (or (false? hide-content?) (not effective-collapsed?)) children))))))